module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_03_6DB79_1SB_GKK.5a408314.png";